import React from 'react';
import { Facebook, Twitter, Instagram, Mail, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark pt-20 pb-10 border-t border-white/10" data-id="element-52">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-53">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-54">
          <div className="lg:col-span-2" data-id="element-55">
            <a href="#" className="inline-block mb-6" data-id="element-56">
              <img src="https://cdn.magicpatterns.com/uploads/9c4e7vYPBAjAafuRJRjWho/Guzman_Congress_Logo_FINAL-reverse-alt.svg" alt="Elizabeth Guzmán - Democrat for Congress" className="h-[8.5rem] object-contain" data-id="element-57" />
            </a>
            <p className="text-white/60 font-light max-w-sm mb-8 leading-relaxed" data-id="element-58">
              Fighting for working families, healthcare for all, and an economy
              that works for everyone in Virginia, not just the privileged few.
            </p>
            <div className="flex items-center gap-4" data-id="element-59">
              <a href="https://www.facebook.com/elizabethguzmanva/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-sky hover:text-navy transition-colors" data-id="element-60">
                <Facebook size={18} data-id="element-61" />
              </a>
              <a href="https://x.com/guzman4virginia" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-sky hover:text-navy transition-colors" data-id="element-62">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-63">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-64" />
                </svg>
              </a>
              <a href="https://www.instagram.com/guzman4virginia/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-sky hover:text-navy transition-colors" data-id="element-65">
                <Instagram size={18} data-id="element-66" />
              </a>
              <a href="https://bsky.app/profile/guzman4virginia.bsky.social" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-sky hover:text-navy transition-colors" data-id="element-67">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-68">
                  <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.6 6.463.785 2.878 3.593 3.834 6.092 3.57-4.29.52-8.1 2.592-3.592 7.2 4.8 4.8 7.2-.6 8.9-4.8 1.7 4.2 3.1 9.6 8.9 4.8 4.508-4.608.698-6.68-3.592-7.2 2.5.264 5.307-.692 6.092-3.57.222-.813.6-5.773.6-6.463 0-.688-.139-1.86-.902-2.203-.66-.299-1.664-.621-4.3 1.24C16.046 4.747 13.087 8.686 12 10.8Z" data-id="element-69" />
                </svg>
              </a>
              <a href="https://www.youtube.com/@elizabethguzman188" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-sky hover:text-navy transition-colors" data-id="element-70">
                <Youtube size={18} data-id="element-71" />
              </a>
            </div>
          </div>

          <div data-id="element-72">
            <h4 className="text-white font-bold tracking-widest uppercase text-sm mb-6" data-id="element-73">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-74">
              <li data-id="element-75">
                <a href="/about" className="text-white/60 hover:text-sky transition-colors font-light" data-id="element-76">
                  Meet Elizabeth
                </a>
              </li>
              <li data-id="element-77">
                <a href="/district" className="text-white/60 hover:text-sky transition-colors font-light" data-id="element-78">
                  About VA-7
                </a>
              </li>
              <li data-id="element-79">
                <a href="/volunteer" className="text-white/60 hover:text-sky transition-colors font-light" data-id="element-80">
                  Volunteer
                </a>
              </li>
              <li data-id="element-81">
                <a href="/media" className="text-white/60 hover:text-sky transition-colors font-light" data-id="element-82">
                  Media Toolkit
                </a>
              </li>
              <li data-id="element-83">
                <a href="https://secure.actblue.com/donate/guzman_va_web" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-sky transition-colors font-light" data-id="element-84">
                  Donate
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-85">
            <h4 className="text-white font-bold tracking-widest uppercase text-sm mb-6" data-id="element-86">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-87">
              <li className="flex items-center gap-3 text-white/60 font-light" data-id="element-88">
                <Mail size={16} className="text-sky" data-id="element-89" />
                <a href="mailto:info@guzmanforvirginia.com" className="hover:text-white transition-colors" data-id="element-90">
                  info@guzmanforvirginia.com
                </a>
              </li>
              <li className="text-white/60 font-light mt-6" data-id="element-91">
                <span className="text-red font-medium" data-id="element-92">
                  Make Checks Payable to:
                </span>
                <br data-id="element-93" />
                Guzmán for Congress
                <br data-id="element-94" />
                PO Box 74
                <br data-id="element-95" />
                Nokesville, VA 20182
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-96">
          <div className="border border-white/20 p-4 text-center text-white/50 text-xs uppercase tracking-wider max-w-md mx-auto md:mx-0" data-id="element-97">
            Paid for by Guzmán for Congress
          </div>

          <div className="text-white/40 text-sm font-light text-center md:text-right" data-id="element-98">
            &copy; {new Date().getFullYear()} Guzmán for Congress. All rights
            reserved.
            <br data-id="element-99" />
            <a href="#" className="hover:text-white transition-colors" data-id="element-100">
              Privacy Policy
            </a>{' '}
            |{' '}
            <a href="#" className="hover:text-white transition-colors" data-id="element-101">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}